import httpService from "./httpService";
import utils from "./utils";

export default {

  findAll( form, pageable) {
    let params = utils.merge(form, pageable);
    return httpService.get("/systemConfig/findAll", {params: params});
  },
  findById(id) {
    return httpService.get(`/systemConfig/${id}`)
  },

  getScanFileName() {
    return httpService.get(`/systemConfig/getScanFileName`)
  },
  save(form) {
    return httpService.post("/systemConfig", form);
  },
  update(id, form) {
    return httpService.put(`/systemConfig/${id}`, form)
  },
  delete(id) {
    return httpService.delete(`/systemConfig/${id}`)
  }

};



// WEBPACK FOOTER //
// ./src/services/systemConfigService.js